export const ERROR_MESSAGES = {
    UPDATE_SUCCESS: 'Cập nhật thành công!',
    UPDATE_FAIL: 'Cập nhật thất bại!',
};
